import PropTypes from "prop-types";
import React from "react";
import PdfThumbnail from "./PdfThumbnail";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import listingSource from "../Constants/listingSource";
import { useMatomo } from '@datapunt/matomo-tracker-react';
import RegionColors from "./RegionColors";
import LISTINGSIMAGE from "../assets/ListingsImage.jpg";
import APPOINTMENTDEFAULTIMAGE from "../assets/Appointments.png";
import { ClipLoader } from "react-spinners";
import mediaType from "../Constants/mediaType.js";


function ListingsFeed({ listing, terminalView, iFrame = false }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const navigateTo = (path) => {
        if (path) {
            navigate(path);
        }
    };
    const { trackEvent } = useMatomo();
    const matomoStatus = process.env.REACT_APP_MATOMO_STATUS === 'True';
    const pdfMedia = listing.media?.find(m => m.mediaType === mediaType.PDF && m.signedUrl);

    const [imageLoaded, setImageLoaded] = React.useState(false);

    const handleListingClick = () => {
        // Track the event with Matomo
        if (matomoStatus) {
            trackEvent({
                category: 'Listing',
                action: 'Click',
                name: listing.title,
                value: listing.id,
            });
        }

        if (listing.source === listingSource.INSTAGRAM && listing.externalId && listing.externalId.startsWith('https://www.instagram.com')) {
            window.open(listing.website, '_blank');
        }
        else if (iFrame) {
            navigateTo(`/IframeListing?listingId=${listing.id}`
            );
        } else if (
            listing.source === listingSource.USER_ENTRY ||
            listing.showExternal === 0
        ) {
            const url = `/Listing?listingId=${listing.id}${terminalView ? "&terminalView=true" : ""}`

            navigateTo(url);
        } else if (
            (listing.source === listingSource.SCRAPER &&
                listing.showExternal === 1) ||
            listing.source === listingSource.INSTAGRAM
        ) {
            window.location.href = listing.website; // web scraper and Instagram
        } else {
            window.location.href = listing.website;
        }
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
                handleListingClick(listing);
            }}
            className={`bg-white rounded-xl p-4 mb-4 shadow-[0_3px_10px_rgb(0,0,0,0.2)] flex flex-col h-auto self-start cursor-pointer hover:shadow-xl transition-all duration-300 transform hover:translate-y-1`}
        >
            <div className="px-4 bg-white py-4 rounded-t-lg">
                <h2 className="text-lg md:text-2xl font-bold text-gray-800">
                    {listing.title}
                </h2>
                <div
                    className="text-start items-start"
                    style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                >
                    <p
                        className={`${RegionColors.darkTextColorV2} my-2 title-font text-sm font-semibold`}
                        style={{ fontFamily: "'Space Grotesk', Helvetica, Arial, Lucida, sans-serif" }}
                    >
                        {listing.startDate &&
                            `${new Date(listing.startDate.slice(0, 10)).toLocaleDateString("de-DE")} (
                            ${new Date(listing.startDate.replace("Z", "")).toLocaleTimeString("de-DE", {
                                hour: "2-digit",
                                minute: "2-digit",
                                timeZone: "Europe/Berlin",
                            })})`
                        }
                        {listing.endDate && (
                            <>
                                <span className={`${RegionColors.darkTextColorV2}`}> {t("To")} </span>
                                {`${new Date(listing.endDate.slice(0, 10)).toLocaleDateString("de-DE")} (
                                ${new Date(listing.endDate.replace("Z", "")).toLocaleTimeString("de-DE", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    timeZone: "Europe/Berlin",
                                })})`}
                            </>
                        )}
                    </p>
                </div>
                <p className={`${RegionColors.darkTextColorV2} my-2 text-sm font-semibold`}
                    dangerouslySetInnerHTML={{ __html: listing.description }} />
            </div>

            <div className="flex gap-2 p-2 overflow-x-auto">
                {pdfMedia ? (
                    <div className="w-28 h-40 object-cover rounded-lg border border-gray-300 cursor-pointer">
                        <PdfThumbnail pdfUrl={pdfMedia.signedUrl} />
                    </div>
                ) : listing.media?.some(m => m.mediaType === mediaType.IMAGE && m.signedUrl) ? (
                    <>
                        {!imageLoaded && (
                            <div className="w-28 h-40 flex items-center justify-center">
                                <ClipLoader color="#36D7B7" size={30} />
                            </div>
                        )}
                        <img
                            alt="Listing"
                            className={`w-28 h-40 object-cover rounded-lg cursor-pointer transition-opacity duration-500 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
                            src={listing.media.find(m => m.mediaType === mediaType.IMAGE && m.signedUrl)?.signedUrl}
                            onLoad={() => setImageLoaded(true)}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = listing.appointmentId ? APPOINTMENTDEFAULTIMAGE : LISTINGSIMAGE;
                                setImageLoaded(true);
                            }}
                        />
                    </>
                ) : (
                    <img
                        alt="Listing"
                        className="w-28 h-40 object-cover rounded-lg cursor-pointer"
                        src={LISTINGSIMAGE}
                    />
                )}
            </div>
        </div>
    );
}

ListingsFeed.propTypes = {
    listing: PropTypes.object.isRequired,
    terminalView: PropTypes.bool,
    iFrame: PropTypes.bool
};

export default ListingsFeed;